import { useEffect, useState } from 'react';
import axios from 'axios';

import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import { minorToMajor } from '@/lib/quoteMoney';

const API_URL = process.env.REACT_APP_API_URL;

export function MasterVariantSelect({
  familyId,
  sectorKey,
  value,
  disabled,
  onChange,
  compact = false,
  lang = 'tr',
}) {
  const [family, setFamily] = useState(null);

  useEffect(() => {
    setFamily(null);
    if (!familyId) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(
          `${API_URL}/api/quote/master-catalog/families/${encodeURIComponent(familyId)}`,
          {
            params: sectorKey ? { sector_key: sectorKey, locale: lang } : { locale: lang },
            withCredentials: true,
          },
        );
        if (!cancelled) setFamily(data);
      } catch {
        if (!cancelled) setFamily(null);
      }
    })();
    return () => { cancelled = true; };
  }, [familyId, sectorKey, lang]);

  const variants = family?.variants || [];
  if (!familyId || variants.length === 0) return null;

  return (
    <Select
      value={value || ''}
      onValueChange={(variantId) => {
        const variant = variants.find((row) => row.variant_id === variantId);
        if (!variant) return;
        const price = Number(variant.unit_price_minor || 0);
        const cost = Number(variant.cost_price_minor || 0);
        onChange({
          master_family_id: family.family_id,
          master_variant_id: variant.variant_id,
          master_catalog_revision: family.catalog_revision,
          technical_attributes: variant.technical_attributes || {},
          name: `${family.display_name || family.name} — ${variant.display_name || variant.name}`,
          unit: family.display_unit || family.default_unit || 'adet',
          unit_price_major: price > 0 ? minorToMajor(price).toString() : '',
          cost_price_major: cost > 0 ? minorToMajor(cost).toString() : '',
          price_unset: price <= 0,
        });
      }}
      disabled={disabled}
    >
      <SelectTrigger className={compact ? 'h-8 min-w-[150px] text-xs' : ''}>
        <SelectValue placeholder={lang === 'en' ? 'Select variant' : 'Varyant seç'} />
      </SelectTrigger>
      <SelectContent>
        {variants.map((variant) => (
          <SelectItem key={variant.variant_id} value={variant.variant_id}>
            {variant.display_name || variant.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
